import _ from 'lodash'

import { ApiHelper } from '../../../helpers/apihelper'
import * as Constants from '../../../helpers/constants'

/* Data Pulse concurrency-limit data-access seam (search-then-edit form below the fair-usage
 * breakdown table). Backend (sfcloud BFF) exposes user_concurrency_limit / org_concurrency_limit
 * (read, raw stored value) and update_user_concurrency_limit / update_org_concurrency_limit
 * (write) under api/v1/{client}/data_pulse/<op> -- mirrors trial_service.js's shape.
 */
const isSuccess = (response) => response && response.status === Constants.CO_API.SUCCESS

// ---- Read: { configured: {min,max}|null, default_min, pool_size } ------------
export const fetchUserConcurrencyLimit = (client, { userId }, signal = null) => {
  const body = _.pick({ user_id: userId }, ApiHelper(client, 'DATA_PULSE_USER_CONCURRENCY_LIMIT').API_BODY)
  return ApiHelper(client, 'DATA_PULSE_USER_CONCURRENCY_LIMIT').API(client, body, signal)
    .then((response) => (isSuccess(response) ? response.data : null))
}

export const fetchOrgConcurrencyLimit = (client, { orgId }, signal = null) => {
  const body = _.pick({ org_id: orgId }, ApiHelper(client, 'DATA_PULSE_ORG_CONCURRENCY_LIMIT').API_BODY)
  return ApiHelper(client, 'DATA_PULSE_ORG_CONCURRENCY_LIMIT').API(client, body, signal)
    .then((response) => (isSuccess(response) ? response.data : null))
}

const runAction = (client, helperKey, params) => {
  const body = _.pick(params, ApiHelper(client, helperKey).API_BODY)
  return ApiHelper(client, helperKey).API(client, body)
    .then((response) => {
      if (!isSuccess(response)) throw new Error((response && response.message) || 'Request failed')
      return response.data || {}
    })
}

// coUserId/coOrgId = target; operatorId = logged-in CRM operator (recorded in the audit).
export const updateUserConcurrencyLimit = (client, { coUserId, operatorId, concurrencyLimits, reason }) =>
  runAction(client, 'DATA_PULSE_UPDATE_USER_CONCURRENCY_LIMIT',
    { co_user_id: coUserId, user_id: operatorId, concurrency_limits: concurrencyLimits, reason })

export const updateOrgConcurrencyLimit = (client, { coOrgId, operatorId, concurrencyLimits, reason }) =>
  runAction(client, 'DATA_PULSE_UPDATE_ORG_CONCURRENCY_LIMIT',
    { co_org_id: coOrgId, user_id: operatorId, concurrency_limits: concurrencyLimits, reason })
